// Offer placement ids. Kept free of runtime imports so pages can import an id
// without pulling analytics code. Each string is an analytics key: the Analytics dbt models
// and dashboards group offer events by `placement`, so never rename one.
// (Replaced the generated value_surface_placements.yaml projection, 2026-11.)

export const RUNTIME_OFFER_PLACEMENT_DASAMSA_REPORT_BRIDGE = "/dasamsa_report_bridge" as const;
export const RUNTIME_OFFER_PLACEMENT_DASHA_CALCULATOR_REPORT_BRIDGE =
  "/dasha-calculator_report_bridge" as const;
export const RUNTIME_OFFER_PLACEMENT_HI_DASAMSA_REPORT_BRIDGE =
  "/hi/dasamsa_report_bridge" as const;
export const RUNTIME_OFFER_PLACEMENT_HI_DASHA_CALCULATOR_REPORT_BRIDGE =
  "/hi/dasha-calculator_report_bridge" as const;
export const RUNTIME_OFFER_PLACEMENT_HI_LAL_KITAB_REPORT_BRIDGE =
  "/hi/lal_kitab_report_bridge" as const;
export const RUNTIME_OFFER_PLACEMENT_HI_MUHURAT_REPORT_BRIDGE =
  "/hi/muhurat_report_bridge" as const;
export const RUNTIME_OFFER_PLACEMENT_HI_NAVAMSA_CHART_REPORT_BRIDGE =
  "/hi/navamsa_chart_report_bridge" as const;
export const RUNTIME_OFFER_PLACEMENT_HI_RASHI_CALCULATOR_REPORT_BRIDGE =
  "/hi/rashi_calculator_report_bridge" as const;
export const RUNTIME_OFFER_PLACEMENT_HI_SADE_SATI_REPORT_BRIDGE =
  "/hi/sade-sati_report_bridge" as const;
export const RUNTIME_OFFER_PLACEMENT_HI_SHADBALA_REPORT_BRIDGE =
  "/hi/shadbala_report_bridge" as const;
export const RUNTIME_OFFER_PLACEMENT_LAL_KITAB_REPORT_BRIDGE = "/lal_kitab_report_bridge" as const;
export const RUNTIME_OFFER_PLACEMENT_MUHURAT_REPORT_BRIDGE = "/muhurat_report_bridge" as const;
export const RUNTIME_OFFER_PLACEMENT_NAVAMSA_CHART_REPORT_BRIDGE =
  "/navamsa_chart_report_bridge" as const;
export const RUNTIME_OFFER_PLACEMENT_RASHI_CALCULATOR_REPORT_BRIDGE =
  "/rashi_calculator_report_bridge" as const;
export const RUNTIME_OFFER_PLACEMENT_SADE_SATI_REPORT_BRIDGE = "/sade-sati_report_bridge" as const;
export const RUNTIME_OFFER_PLACEMENT_SHADBALA_REPORT_BRIDGE = "/shadbala_report_bridge" as const;
export const RUNTIME_OFFER_PLACEMENT_BABY_NAME_LOOKUP_BELOW_RESULT =
  "baby_name_lookup_below_result" as const;
export const RUNTIME_OFFER_PLACEMENT_BIRTH_IDENTITY_LOOKUP_BELOW_RESULT =
  "birth_identity_lookup_below_result" as const;
export const RUNTIME_OFFER_PLACEMENT_CHAT_READING_PRIMARY = "chat-reading-primary" as const;
export const RUNTIME_OFFER_PLACEMENT_CHAT_EARLY_QUICK_OFFER = "chat_early_quick_offer" as const;
export const RUNTIME_OFFER_PLACEMENT_CHAT_PAYWALL = "chat_paywall" as const;
export const RUNTIME_OFFER_PLACEMENT_GUN_MILAN_RESULTS_PRIMARY =
  "gun_milan_results_primary" as const;
export const RUNTIME_OFFER_PLACEMENT_HI_GUN_MILAN_RESULTS_PRIMARY =
  "hi_gun_milan_results_primary" as const;
export const RUNTIME_OFFER_PLACEMENT_KAAL_SARP_RESULT_PRIMARY = "kaal_sarp_result_primary" as const;
export const RUNTIME_OFFER_PLACEMENT_KUNDALI_RESULT_PRIMARY = "kundali-result-primary" as const;
export const RUNTIME_OFFER_PLACEMENT_KUNDLI_MATCHING_RESULTS_PRIMARY =
  "kundli_matching_results_primary" as const;
export const RUNTIME_OFFER_PLACEMENT_MANGAL_DOSHA_RESULT_PRIMARY =
  "mangal_dosha_result_primary" as const;
export const RUNTIME_OFFER_PLACEMENT_MATCH_SHARE_RESULTS_PRIMARY =
  "match_share_results_primary" as const;
export const RUNTIME_OFFER_PLACEMENT_MUHURAT_EVENT_VALUE_MOMENT =
  "muhurat_event_value_moment" as const;
export const RUNTIME_OFFER_PLACEMENT_NUMEROLOGY_LOOKUP_BELOW_RESULT =
  "numerology_lookup_below_result" as const;
export const RUNTIME_OFFER_PLACEMENT_PITRA_DOSH_RESULT_PRIMARY =
  "pitra_dosh_result_primary" as const;
export const RUNTIME_OFFER_PLACEMENT_REPORT_READING_UPSELL = "report_reading_upsell" as const;
export const RUNTIME_OFFER_PLACEMENT_SHANI_TRANSIT_BELOW_RESULT =
  "shani_transit_below_result" as const;

/**
 * The intent each placement reports on its offer events. The page and SEO code
 * speak a different intent vocabulary ("generic", "chart_report"), so the
 * placement's own value wins whenever it has one; dbt reads it as `$.intent`.
 */
// OfferPlacement.page-bridge derives the "<page>_report_bridge" ids at runtime.
const PLACEMENT_INTENTS = {
  [RUNTIME_OFFER_PLACEMENT_BABY_NAME_LOOKUP_BELOW_RESULT]: "chart_report",
  [RUNTIME_OFFER_PLACEMENT_BIRTH_IDENTITY_LOOKUP_BELOW_RESULT]: "chart_report",
  [RUNTIME_OFFER_PLACEMENT_CHAT_EARLY_QUICK_OFFER]: "chat",
  [RUNTIME_OFFER_PLACEMENT_CHAT_PAYWALL]: "chat",
  [RUNTIME_OFFER_PLACEMENT_CHAT_READING_PRIMARY]: "chat",
  [RUNTIME_OFFER_PLACEMENT_DASAMSA_REPORT_BRIDGE]: "career",
  [RUNTIME_OFFER_PLACEMENT_DASHA_CALCULATOR_REPORT_BRIDGE]: "chart_report",
  [RUNTIME_OFFER_PLACEMENT_GUN_MILAN_RESULTS_PRIMARY]: "chart_report",
  [RUNTIME_OFFER_PLACEMENT_HI_DASAMSA_REPORT_BRIDGE]: "career",
  [RUNTIME_OFFER_PLACEMENT_HI_DASHA_CALCULATOR_REPORT_BRIDGE]: "chart_report",
  [RUNTIME_OFFER_PLACEMENT_HI_GUN_MILAN_RESULTS_PRIMARY]: "chart_report",
  "/hi/kaal-sarp-dosha_report_bridge": "remedy_dosha",
  [RUNTIME_OFFER_PLACEMENT_HI_LAL_KITAB_REPORT_BRIDGE]: "chart_report",
  [RUNTIME_OFFER_PLACEMENT_HI_MUHURAT_REPORT_BRIDGE]: "timing_muhurat",
  [RUNTIME_OFFER_PLACEMENT_HI_NAVAMSA_CHART_REPORT_BRIDGE]: "chart_report",
  "/hi/pitra-dosha_report_bridge": "remedy_dosha",
  [RUNTIME_OFFER_PLACEMENT_HI_RASHI_CALCULATOR_REPORT_BRIDGE]: "chart_report",
  [RUNTIME_OFFER_PLACEMENT_HI_SADE_SATI_REPORT_BRIDGE]: "remedy_dosha",
  [RUNTIME_OFFER_PLACEMENT_HI_SHADBALA_REPORT_BRIDGE]: "chart_report",
  "/kaal-sarp-dosha_report_bridge": "remedy_dosha",
  [RUNTIME_OFFER_PLACEMENT_KAAL_SARP_RESULT_PRIMARY]: "dosha_remedy",
  [RUNTIME_OFFER_PLACEMENT_KUNDALI_RESULT_PRIMARY]: "birth_chart",
  [RUNTIME_OFFER_PLACEMENT_KUNDLI_MATCHING_RESULTS_PRIMARY]: "chart_report",
  [RUNTIME_OFFER_PLACEMENT_LAL_KITAB_REPORT_BRIDGE]: "chart_report",
  // The caller reports its own intent: chart_report, dosha_remedy, matching.
  [RUNTIME_OFFER_PLACEMENT_MANGAL_DOSHA_RESULT_PRIMARY]: null,
  [RUNTIME_OFFER_PLACEMENT_MATCH_SHARE_RESULTS_PRIMARY]: "chart_report",
  [RUNTIME_OFFER_PLACEMENT_MUHURAT_EVENT_VALUE_MOMENT]: "timing_muhurat",
  [RUNTIME_OFFER_PLACEMENT_MUHURAT_REPORT_BRIDGE]: "timing_muhurat",
  [RUNTIME_OFFER_PLACEMENT_NAVAMSA_CHART_REPORT_BRIDGE]: "chart_report",
  [RUNTIME_OFFER_PLACEMENT_NUMEROLOGY_LOOKUP_BELOW_RESULT]: "chart_report",
  "/pitra-dosha_report_bridge": "remedy_dosha",
  [RUNTIME_OFFER_PLACEMENT_PITRA_DOSH_RESULT_PRIMARY]: "pitra_dosh_report",
  [RUNTIME_OFFER_PLACEMENT_RASHI_CALCULATOR_REPORT_BRIDGE]: "chart_report",
  [RUNTIME_OFFER_PLACEMENT_REPORT_READING_UPSELL]: "forecast",
  [RUNTIME_OFFER_PLACEMENT_SADE_SATI_REPORT_BRIDGE]: "remedy_dosha",
  [RUNTIME_OFFER_PLACEMENT_SHADBALA_REPORT_BRIDGE]: "chart_report",
  [RUNTIME_OFFER_PLACEMENT_SHANI_TRANSIT_BELOW_RESULT]: "remedy_dosha",
} as const satisfies Record<string, string | null>;

export type RuntimeOfferPlacementKey = keyof typeof PLACEMENT_INTENTS;

export function isRuntimeOfferPlacementKey(
  placement: string
): placement is RuntimeOfferPlacementKey {
  return Object.prototype.hasOwnProperty.call(PLACEMENT_INTENTS, placement);
}

/** The placement-owned intent, else the caller's. */
export function placementIntent(placement: string, requested?: string): string | undefined {
  const owned = (PLACEMENT_INTENTS as Record<string, string | null>)[placement];
  return owned ?? requested;
}

/** Canonical source-path form used by every offer event. */
export function normalizePath(path: string): string {
  const clean = path.split(/[?#]/, 1)[0] || "/";
  const leading = clean.startsWith("/") ? clean : `/${clean}`;
  return leading === "/" ? leading : leading.replace(/\/+$/, "");
}
